import React from "react";
import { Footer } from "@jds/core";

const FooterComponent = () => <Footer />;

export default FooterComponent;
